import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { useFormContext } from "react-hook-form";
import InsightActionableContainer from "../../Containers/InsightActionableContainer";
import {
  BUTTON_CAMPAIGN_AGENT_APPLY_AND_OPEN_AD,
  BUTTON_CAMPAIGN_AGENT_REVIEW_AND_APPLY,
  BUTTON_CAMPAIGN_AGENT_VIEW_RECOMMENDATION,
  CAMPAIGN_AGENT_CHANGES_COUNT_MANY,
  CAMPAIGN_AGENT_CHANGES_COUNT_ONE,
  CAMPAIGN_AGENT_CREATIVE_BADGE,
  CAMPAIGN_AGENT_SUMMARY_MANUAL,
} from "../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../lib/i18next";
import { ADS_KEYS_CREATIVES } from "../../../utils/constants";
import CampaignAgentChangesSummary from "./CampaignAgentChangesSummary";

const getHasCreativeChanges = (optimization) =>
  (optimization?.changes || []).some((change) =>
    ADS_KEYS_CREATIVES.includes(change?.field)
  );

export const CampaignAgentOptimizationBadges = ({ optimization }) => {
  const { t } = useTranslationApp();
  const changes = Array.isArray(optimization?.changes)
    ? optimization.changes
    : [];
  if (changes.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
      <Chip
        size="small"
        variant="outlined"
        label={t(
          changes.length === 1
            ? CAMPAIGN_AGENT_CHANGES_COUNT_ONE
            : CAMPAIGN_AGENT_CHANGES_COUNT_MANY,
          { count: changes.length }
        )}
      />
      {getHasCreativeChanges(optimization) ? (
        <Chip
          size="small"
          variant="outlined"
          label={t(CAMPAIGN_AGENT_CREATIVE_BADGE)}
        />
      ) : null}
    </Box>
  );
};

const CampaignAgentOptimizationContent = ({
  optimization,
  disabled = false,
  onActionButtonClick = () => {},
}) => {
  const { t } = useTranslationApp();
  const { getValues } = useFormContext();
  const changes = Array.isArray(optimization?.changes)
    ? optimization.changes
    : [];
  const isManual =
    Boolean(optimization?.isExternal) ||
    Boolean(
      getValues(`platformsData.${optimization?.platform}.isIncompatible`)
    );
  const hasCreativeChanges = getHasCreativeChanges(optimization);
  const actionButtonText = isManual
    ? t(BUTTON_CAMPAIGN_AGENT_VIEW_RECOMMENDATION)
    : hasCreativeChanges
      ? t(BUTTON_CAMPAIGN_AGENT_APPLY_AND_OPEN_AD)
      : t(BUTTON_CAMPAIGN_AGENT_REVIEW_AND_APPLY);

  const contentBeforeAction = isManual ? (
    <Typography variant="caption" color="text.secondary">
      {t(CAMPAIGN_AGENT_SUMMARY_MANUAL)}
    </Typography>
  ) : changes.length > 0 ? (
    <CampaignAgentChangesSummary optimization={optimization} />
  ) : null;

  return (
    <InsightActionableContainer
      insight={optimization}
      disabled={disabled}
      showActionButton
      actionButtonText={actionButtonText}
      onActionButtonClick={onActionButtonClick}
      contentBeforeAction={contentBeforeAction}
    />
  );
};

export default CampaignAgentOptimizationContent;
